<template>
	<v-container fluid pt-0 pb-0>
		<v-row wrap>
			<v-col md="8" class="pa-0 hidden-sm-and-down"
				><v-img height="100vh" width="auto" :src="publicPath + 'login_image.jpg'"></v-img
			></v-col>
			<v-col md="4">
				<div style="position: relative; height: 95vh">
					<v-row class="pt-16 pb-8">
						<v-col cols="12" class="text-center pa-0 ma-0">
							<img :src="publicPath + 'login_logo.png'" width="200vh" />
						</v-col>
					</v-row>
					<v-row>
						<v-col class="pa-4 pa-sm-16">
							<v-card class="transparent-login-form" outlined tile v-if="!forgottenPassword">
								<v-card-text>
									<v-row dense>
										<v-col>
											<InputField
												:error="loginValidation.email"
												:label="$t('fields.email')"
												@keyup.native.enter="loginClick"
												v-model="loginData.email"
											></InputField>
										</v-col>
									</v-row>
									<v-row dense>
										<v-col>
											<InputField
												:error="loginValidation.password"
												:label="$t('fields.password')"
												:type="'password'"
												@keyup.native.enter="loginClick"
												v-model="loginData.password"
											></InputField>
										</v-col>
									</v-row>
									<div @click="forgottenPasswordClick" class="cursor-pointer text-right">
										{{ $t('buttons.forgottenPassword') }}
									</div>
								</v-card-text>
								<v-card-actions class="pa-4 pb-2">
									<v-row dense>
										<v-col>
											<v-btn
												depressed
												color="primary"
												@click="loginClick"
												class="white--text float-right"
											>
												<v-icon class="mr-2">fa-sign-in-alt</v-icon>
												{{ $t('buttons.login') }}
											</v-btn>
										</v-col>
										<v-col cols="12" v-if="$getSettings('GOOGLE_LOGIN_CLIENT_ID') != null">
											<div
												id="g_id_onload"
												:data-client_id="$getSettings('GOOGLE_LOGIN_CLIENT_ID')"
												data-context="signin"
												data-ux_mode="popup"
												data-callback="GLogin"
												data-auto_prompt="false"
												class="float-right"
											></div>
											<div
												class="g_id_signin float-right"
												data-type="standard"
												data-shape="rectangular"
												data-theme="filled_black"
												data-text="signin_with"
												data-size="large"
												data-logo_alignment="left"
											></div>
										</v-col>
										<v-col cols="12" class="text-center">
											<div
												class="login-footer"
												:class="{ 'login-footer-dark-theme': $vuetify.theme.dark }"
												v-html="$getSettings('FOOTER_HTML')"
											></div>
										</v-col>
									</v-row>
								</v-card-actions>
							</v-card>
							<v-card class="transparent-login-form" ountlined tile v-if="forgottenPassword">
								<v-card-text>
									<v-row dense>
										<v-col>
											<InputField
												:error="forgottenEmailValidation"
												:label="$t('fields.email')"
												@keyup.native.enter="loginClick"
												v-model="forgottenEmail"
											></InputField>
										</v-col>
									</v-row>
									<v-row dense>
										<v-col class="text-center">
											<div v-html="$t('texts.passwordReset')"></div>
										</v-col>
									</v-row>
								</v-card-text>
								<v-card-actions class="pa-4 pb-2">
									<v-row dense>
										<v-col>
											<v-btn
												depressed
												color="primary"
												class="white--text float-left"
												@click="forgottenPasswordBackClick"
											>
												<v-icon class="mr-2">fa-arrow-left</v-icon>
												{{ $t('buttons.back') }}
											</v-btn>
											<v-btn
												depressed
												color="primary"
												class="white--text float-right"
												@click="forgottenPasswordSendClick"
											>
												<v-icon class="mr-2">fa-paper-plane</v-icon>
												{{ $t('buttons.send') }}
											</v-btn>
										</v-col>
										<v-col cols="12" class="text-center">
											<div class="login-footer" v-html="$getSettings('FOOTER_HTML')"></div>
										</v-col>
									</v-row>
								</v-card-actions>
							</v-card>
						</v-col>
					</v-row>
					<div
						style="
							position: absolute;
							bottom: 0;
							left: 0;
							right: 0;
							margin-left: auto;
							margin-right: auto;
							width: fit-content;
						"
					>
						<v-row>
							<v-col cols="6" class="pl-16 pb-12"
								><v-img width="300px" :src="publicPath + 'eu_image.png'"></v-img
							></v-col>
							<v-col cols="6" class="pr-16 pb-12"
								><v-img width="300px" :src="publicPath + 'cro_image.png'"></v-img
							></v-col>
						</v-row>
					</div>
				</div>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import InputField from './trinkets/InputField';

export default {
	name: 'Login',
	components: { InputField },
	data: function () {
		return {
			publicPath: process.env.BASE_URL,
			loginData: {
				email: '',
				password: '',
				remember_me: false,
			},
			loginValidation: {
				email: '',
				password: '',
			},
			forgottenEmail: '',
			forgottenEmailValidation: '',
			forgottenPassword: false,
		};
	},
	methods: {
		loginClick() {
			let success = true;

			if (this.loginData.email == '') {
				success = false;
				this.loginValidation.email = this.$t('alerts.emailMissing');
			} else {
				if (!this.$checkEmail(this.loginData.email)) {
					success = false;
					this.loginValidation.email = this.$t('alerts.emailFailFormat');
				} else {
					this.loginValidation.email = '';
				}
			}

			if (this.loginData.password == '') {
				success = false;
				this.loginValidation.password = this.$t('alerts.passwordMissing');
			} else {
				this.loginValidation.password = '';
			}

			if (success) {
				let vm = this;
				this.$APICall('post', 'login', this.loginData, (data, success) => {
					if (success) {
						vm.$myStore.commit('setUser', data.user);
						vm.$myStore.commit('setLoggedIn', true);
						vm.$router.push('/gantt');
						if (data.user.version !== this.$getCookie('ide3_version')) {
							this.$setCookie('ide3_version', data.user.version, 30);
							window.location.reload(true);
						}
					} else {
						vm.$alert(vm.$t('alerts.loginFail'));
					}
				});
			}
		},
		forgottenPasswordClick() {
			this.forgottenEmail = '';
			this.forgottenPassword = true;
		},
		forgottenPasswordBackClick() {
			this.forgottenEmail = '';
			this.forgottenPassword = false;
		},
		forgottenPasswordSendClick() {
			let success = true;

			if (this.forgottenEmail == '') {
				success = false;
				this.forgottenEmailValidation = this.$t('alerts.emailMissing');
			} else {
				if (!this.$checkEmail(this.forgottenEmail)) {
					success = false;
					this.forgottenEmailValidation = this.$t('alerts.emailFailFormat');
				} else {
					this.forgottenEmailValidation = '';
				}
			}

			if (success) {
				let vm = this;
				this.$APICall('post', 'password-recovery', { email: this.forgottenEmail }, (data, success) => {
					if (success) {
						vm.$alert(vm.$t('alerts.passwordResetSuccess'));
						this.forgottenEmail = '';
						this.forgottenPassword = false;
					} else {
						vm.$alert(vm.$t('alerts.passwordResetFail'));
					}
				});
			}
		},
		resolveGoogleLogin(response) {
			let vm = this;
			let payload = {
				token: response.credential,
				remember_me: this.loginData.remember_me,
			};
			this.$APICall('post', 'google-login', payload, (data, success) => {
				if (success) {
					vm.$myStore.commit('setUser', data.user);
					vm.$myStore.commit('setLoggedIn', true);
					vm.$router.push('/gantt');

					if (data.user.version !== this.$getCookie('ide3_version')) {
						this.$setCookie('ide3_version', data.user.version, 30);
						window.location.reload(true);
					}
				} else {
					if (data.internal_message != 'account expired') {
						vm.$alert(vm.$t('alerts.loginFail'));
					} else {
						vm.$alert(vm.$t('alerts.accountExpired'));
					}
				}
			});
		},
	},
	mounted() {
		this.$myStore.commit('setUser', null);
		this.$myStore.commit('setLoggedIn', false);

		const googleScript = document.createElement('script');
		googleScript.setAttribute('src', 'https://accounts.google.com/gsi/client');
		document.head.appendChild(googleScript);
		window.GLogin = (response) => {
			this.resolveGoogleLogin(response);
		};
	},
};
</script>

<style>
.transparent-login-form {
	background-color: rgba(120, 120, 120, 0.1) !important;
	border-color: transparent !important;
}
.login-footer {
	color: rgba(0, 0, 0, 0.6);
}
.login-footer-dark-theme {
	color: rgba(255, 255, 255, 0.6);
}
.login-footer a {
	text-decoration: none;
}
</style>
